export default "\n<div class=\"no-internet-main\">\n    <p class=\"text-center siteFontMedium no-internet-text\">Check you internet connection</p>\n</div>\n"